import { __extends } from "tslib";
import React from 'react';
import { makeId } from '../utils/utils';
import S from './Switch.styl';
var Switch = /** @class */ (function (_super) {
    __extends(Switch, _super);
    function Switch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isChecked: false,
        };
        _this.switchId = 'id_' + makeId(10);
        _this.onChange = function (event) {
            _this.setState({ isChecked: !_this.state.isChecked });
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        return _this;
    }
    Switch.prototype.componentDidMount = function () {
        this.setState({ isChecked: this.props.defaultChecked === true });
    };
    Switch.prototype.render = function () {
        var props = this.props;
        var isChecked = this.state.isChecked;
        var _a = props.width, width = _a === void 0 ? 50 : _a, _b = props.height, height = _b === void 0 ? 28 : _b;
        return (React.createElement("div", { className: S.switchy + " " + (props.className || ''), style: { maxWidth: width, maxHeight: height } },
            React.createElement("input", { className: S.switchInput, type: "checkbox", name: props.name, id: this.switchId, checked: isChecked, onChange: this.onChange }),
            React.createElement("label", { className: S.switchLabel, htmlFor: this.switchId, style: { width: width, height: height } },
                React.createElement("span", { className: S.switchLabelBefore, style: { lineHeight: height, height: height, width: height, left: (isChecked) ? 'calc(100% - ' + height + 'px)' : 0 } }))));
    };
    return Switch;
}(React.PureComponent));
export { Switch };
